// components/PatientQuestionsCard.jsx
import React, { useState, useMemo } from 'react';
import { Card, Collapse, Pagination, Spin, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;
const { Panel } = Collapse;

const PAGE_SIZE = 3;

const PatientQuestionsCard = ({ answers, loading }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedAnswers = useMemo(() => {
    return answers.slice(
      (currentPage - 1) * PAGE_SIZE,
      currentPage * PAGE_SIZE
    );
  }, [answers, currentPage]);

  // Don't render if no answers
  if (answers.length === 0) {
    return null;
  }

  return (
    <Card
      title={
        <span className="text-primary font-medium">Answered Questions</span>
      }
      bordered={false}
      className="mb-6 bg-[#f9fafa]"
    >
      <Spin spinning={loading}>
        <Collapse
          accordion
          className="bg-white rounded-md border border-primary/40"
        >
          {paginatedAnswers.map((item, index) => (
            <Panel
              header={
                <span className="font-semibold text-[#298d9f]">
                  Q{(currentPage - 1) * PAGE_SIZE + index + 1}:{' '}
                  {item.questionText}
                </span>
              }
              key={`${item.id || index}-${currentPage}`}
            >
              <Text className="text-gray-700">{item.answerText}</Text>
            </Panel>
          ))}
        </Collapse>
        
        {answers.length > PAGE_SIZE && (
          <div className="flex justify-center mt-4">
            <Pagination
              current={currentPage}
              total={answers.length}
              pageSize={PAGE_SIZE}
              onChange={setCurrentPage}
              showSizeChanger={false}
              size="small"
            />
          </div>
        )}
      </Spin>
    </Card>
  );
};

PatientQuestionsCard.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    questionText: PropTypes.string.isRequired,
    answerText: PropTypes.string.isRequired
  })).isRequired,
  loading: PropTypes.bool
};

PatientQuestionsCard.defaultProps = {
  loading: false
};

export default PatientQuestionsCard;